import { render, staticRenderFns } from "./picList.vue?vue&type=template&id=19689ab2&scoped=true"
import script from "./picList.vue?vue&type=script&lang=js"
export * from "./picList.vue?vue&type=script&lang=js"
import style0 from "./picList.vue?vue&type=style&index=0&id=19689ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19689ab2",
  null
  
)

export default component.exports